// Packages
import React, { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useClearAuth, useAuth } from "../context/authprovider";
import { Dropdown, ButtonToolbar } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import Button from 'rsuite/Button';
import IconButton from 'rsuite/IconButton';

// Components
import {
  logoutApi,
  checkAccessTokenApi,
  refreshTokenApi,
} from "../services/auth";

const NavBar = () => {
  const clearAuthState = useClearAuth();
  const navigate = useNavigate();
  const { role } = useAuth();

  const logoutUser = async () => {
    const logoutResult = await logoutApi();

    if (logoutResult) {
      clearAuthState();
      navigate("/login");
    }
  };

  // let Links = [
  //   { name: "Home", link: "/", icon: "home-outline" },
  //   { name: "Profile", link: "/profile", icon: "people-circle-outline" },
  //   // {name:"Log Out",link:"/",icon:"log-out-outline"},
  // ];
  return (
    <div className="shadow-md w-full fixed top-0 left-0">
      <div className="md:flex items-center justify-between bg-white py-4 md:px-10 px-7">
        <div
          className="font-bold text-2xl cursor-pointer flex items-center font-[Poppins] 
      text-gray-800"
        >
          <span className="text-3xl text-indigo-600 mr-1 pt-2">
            <ion-icon name="book-outline"></ion-icon>
          </span>
          Ask Me Anything
        </div>
        <ul className={"md:flex md:items-center"}>
          {role === "admin" ?
            <li className="md:ml-8 text-xl md:my-0 my-7">
              <ButtonToolbar>
                <Dropdown title="Admin Panel" activeKey="e-2">
                  <Dropdown.Menu title="Topics">
                    <Dropdown.Item >
                      <div className="dropdown-content">
                        <a
                          href="/admin/createtopic"
                          className="text-gray-800 hover:text-gray-400 duration-500"
                        >
                          Create Topic
                        </a>
                      </div>
                    </Dropdown.Item>

                    <Dropdown.Item >
                      <div className="dropdown-content">
                        <a
                          href="/admin/deletetopic"
                          className="text-gray-800 hover:text-gray-400 duration-500"
                        >
                          Delete Topic
                        </a>
                      </div>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                  <Dropdown.Menu title="Ban">
                    <Dropdown.Item>
                      <div className="dropdown-content">
                        <a
                          href="/admin/banuser"
                          className="text-gray-800 hover:text-gray-400 duration-500"
                        >
                          Ban User
                        </a>
                      </div>
                    </Dropdown.Item>

                    <Dropdown.Item>
                      <div className="dropdown-content">
                        <a
                          href="/admin/unbanuser"
                          className="text-gray-800 hover:text-gray-400 duration-500"
                        >
                          Unban User
                        </a>
                      </div>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </ButtonToolbar>
            </li>
            :
            <div></div>
          }
          {/* {Links.map((link) => (
            <li key={link.name} className="md:ml-8 text-xl md:my-0 my-7">
              <ButtonToolbar>
                <ion-icon name={link.icon} placement="left"></ion-icon>
                <a
                  href="{link.link}"
                  className="text-gray-800 hover:text-gray-800 duration-500 text-sm"
                >
                 {link.name}
                </a>
              </ButtonToolbar>
            </li>
          ))} */}

          { (role === "admin" || role ==="user") ? 
          <>
          <ButtonToolbar>
            <ion-icon name="home-outline"></ion-icon>
            <a
              href="/"
              className="text-gray-800 hover:text-gray-800 duration-500 text-sm"
            >
              Home
            </a>
          </ButtonToolbar>
          
          <ButtonToolbar>
            <Dropdown title="Profile">
                <Dropdown.Item >
                  <div className="dropdown-content">
                    <a
                      href="/profile"
                      className="text-gray-800 hover:text-gray-400 duration-500"
                    >Profile
                    </a>
                  </div>
                </Dropdown.Item>
                <Dropdown.Item>
                  <div className="dropdown-content">
                    <a
                      href="/changepassword"
                      className="text-gray-800 hover:text-gray-400 duration-500"
                    >Change Password
                    </a>
                  </div>
                </Dropdown.Item>
            </Dropdown>
          </ButtonToolbar>
          </>
          :
          <div></div>
          }
          
          <ButtonToolbar>
            <ion-icon name="log-out-outline"></ion-icon>
            <button onClick={logoutUser}>Logout</button>
          </ButtonToolbar>
        </ul>
      </div>
    </div >
  );
};

export default NavBar;